export const TransactionStatus = (
  isCompleted: boolean,
  isRejected: boolean,
  isCanceled: boolean,
) => {
  const status = isCanceled ? 3 : isRejected ? 2 : isCompleted ? 1 : 0;
  switch (status) {
    case 0:
      return (
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <span className="text-[#FFEB33]">Pending</span>
          </div>
        </div>
      );
    case 1:
      return (
        <div className="flex items-center gap-2">
          <span className="text-[#33FF3B]">Approved</span>
        </div>
      );
    case 2:
      return (
        <div className="flex items-center gap-2">
          <span className="text-danger">Rejected</span>
        </div>
      );
    case 3:
      return (
        <div className="flex items-center gap-2">
          <span className="text-white">Canceled</span>
        </div>
      );

    default:
      return (
        <div className="flex items-center gap-2">
          <span className="text-[#33FF3B]">Success</span>
        </div>
      );
  }
};
